import React, { Component } from "react";
import { convertDateFormat } from "../../utils/helperFunctions";
import { MDBBtn, MDBDataTable } from "mdbreact";
import { Row, Col } from "reactstrap";
import Pagination from "../Common/Pagination";
import { translate } from "react-i18next";

class AlarmsTable extends Component {
  state = {
    loadTable: false,
    deviceList: [],
    pagination: {},
    role: localStorage.getItem("role"),
  };

  columns = [
    {
      label: this.props.t("dashboard.devicesID"),
      field: "deviceId",
      sort: "asc",
      width: 250,
    },
    {
      label: this.props.t("dashboard.alarmName"),
      field: "name",
      sort: "asc",
      width: 250,
    },
    {
      label: this.props.t("dashboard.deviceName"),
      field: "deviceName",
      sort: "asc",
      width: 250,
    },
    {
      label: this.props.t("dashboard.type"),
      field: "type",
      sort: "asc",
      width: 250,
    },
    {
      label: this.props.t("dashboard.createdAt"),
      field: "createdAt",
      sort: "asc",
      width: 250,
    },

    //   {
    //     label: 'Action',
    //     field: 'action',
    //     width: 80,
    //   },
  ];

  componentDidMount() {
    const { devices } = this.props;
    if (devices && devices.length) {
      this.showTable(true);
    } else {
      this.showTable(false);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.devices !== this.props.devices &&
      this.props.devices &&
      this.props.devices.length
    ) {
      this.showTable(true);
    }
  }

  showTable = (loadTable) => {
    if (loadTable) {
      const { devices, pagination, updateFirmware } = this.props;

      const rows = devices.map((devices, index) => {
        let gatewayRow = { ...devices };
        delete gatewayRow["userId"];
        gatewayRow.createdAt = convertDateFormat(
          gatewayRow.createdAt,
          "shortDateTime"
        );
        gatewayRow.action = (
          <MDBBtn
            onClick={() => updateFirmware(devices.deviceId)}
            tag="a"
            rounded
            size="sm"
            className="px-2 transparentBtn"
          >
            <i className="fas fa-cog mt-0"></i>
          </MDBBtn>
        );

        return gatewayRow;
      });
      this.setState({
        loadTable,
        deviceList: {
          columns: this.columns,
          rows: rows,
        },
        pagination,
      });
    } else {
      this.setState({ loadTable });
    }
  };

  render() {
    const { changePage, t } = this.props;
    const { loadTable, deviceList, pagination } = this.state;
    return (
      <React.Fragment>
        {loadTable ? (
          <>
            <MDBDataTable
              className="hideLastColSort"
              bordered
              data={deviceList}
              paging={false}
              scrollX
              searchLabel={t("dashboard.search")}
            />
            <Row className="mt-3 mb-3">
              <Col lg={6}>
                <label>
                  {t("dashboard.showing")} {pagination.currentPage * 10 - 9}{" "}
                  {t("dashboard.to")} {pagination.currentPage * 10}{" "}
                  {t("dashboard.of")} {t("dashboard.result")}
                </label>
              </Col>
              <Col lg={6} className="text-right">
                <Pagination
                  pagination={pagination}
                  changePage={(page) => changePage(page)}
                ></Pagination>
              </Col>
            </Row>
          </>
        ) : null}
      </React.Fragment>
    );
  }
}

export default translate("translations")(AlarmsTable);
